import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { IsEnglish } from '../../utils/language';
import { toDisplayDecimal } from '../../utils';
import styles from '../../styles/timesheet.module.css';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    }
}));


export default function TimesheetBankWeekSummary(props) {
    const classes = useStyles();

    const [dataWeek, setDataWeek] = React.useState(null);

    const { data } = props;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setDataWeek(data);
    }

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const header = document.querySelector('[data-id=headerTimesheetDetail]').offsetHeight;
            const offSet = 30;

            const customHeight = height - header - offSet;

            document.querySelector('#divDetail').style.height = `${customHeight}px`;
            document.querySelector('#divDetail').style.overflowX = 'hidden';
        }, 1000);
    }

    return (
        <div id="divWeekSymmary">
            <List>
                {dataWeek != null && dataWeek.map((obj, index) =>
                    <React.Fragment key={index}>
                        <ListItem key={index}>
                            <ListItemIcon className={styles.listItemIcon}>
                                <ArrowRightIcon />
                            </ListItemIcon>
                            <ListItemText primary={
                                <React.Fragment>
                                    <div className={classes.firstCell}>{IsEnglish() ? obj.scEn : obj.scFr}</div>
                                    <div className={classes.secondCell}>{toDisplayDecimal(obj.duration)}</div>
                                </React.Fragment>
                            } />
                        </ListItem>
                    </React.Fragment>
                )}
            </List>
        </div>
    );
}